import type { CityConfig } from "../city-template/types";

export const saginawConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Saginaw County Clerk", href: "https://www.saginawcounty.com/clerk", description: "Saginaw County Clerk — marriage license issuance" },
    { label: "Divorce Records — Saginaw County Clerk", href: "https://www.saginawcounty.com/clerk", description: "Saginaw County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Saginaw",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "saginaw",
  route: "/saginaw",
  title: "Emergency Passport Saginaw, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Saginaw, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Saginaw, Bay City, Midland, Frankenmuth, and all Great Lakes Bay residents. MBS International Airport coverage. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Saginaw, MI",
  heroSubtitle: "Saginaw travelers — Great Lakes Bay residents, MBS International Airport flyers, Frankenmuth tourists, and international families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Saginaw County and the Great Lakes Bay region.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20Saginaw%20Michigan%20riverfront%20and%20downtown%20skyline%20along%20the%20Saginaw%20River%2C%20historic%20buildings%2C%20modern%20waterfront%2C%20lush%20green%20trees%2C%20warm%20golden%20hour%20light%2C%20clear%20blue%20sky%2C%20Great%20Lakes%20Bay%20region%20landscape%2C%20no%20text%20no%20people%2C%20cinematic%20landscape%20photography&width=1800&height=700&seq=saginaw-hero-001&orientation=landscape",
  heroImageAlt: "Saginaw Michigan riverfront and downtown skyline along the Saginaw River at golden hour",
  geoPosition: "43.4195;-83.9508",
  geoPlacename: "Saginaw, Michigan",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 100 miles southeast of Saginaw — appointments required, typically booked 2 weeks out",
  },
  nearbyCitiesZips: [
    { name: "Saginaw", zips: "48601, 48602, 48603, 48604, 48605, 48607, 48638" },
    { name: "Saginaw Township", zips: "48603, 48604, 48609" },
    { name: "Bay City", zips: "48706, 48707, 48708, 48710" },
    { name: "Midland", zips: "48640, 48641, 48642, 48667, 48670" },
    { name: "Frankenmuth", zips: "48734, 48787" },
    { name: "Bridgeport", zips: "48722" },
    { name: "Freeland", zips: "48623" },
    { name: "Buena Vista", zips: "48601" },
    { name: "Hemlock", zips: "48626" },
    { name: "Merrill", zips: "48637" },
    { name: "St. Charles", zips: "48655" },
    { name: "Birch Run", zips: "48415" },
    { name: "Clio", zips: "48420" },
    { name: "Mount Morris", zips: "48458" },
    { name: "Vassar", zips: "48768" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-global-line", title: "Great Lakes Bay Expertise", desc: "MBS International Airport, Frankenmuth, and cruise travel passport support" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from anywhere in Saginaw County" },
  ],
  internalLinks: [
    { name: "Expedited passport in Flint, MI", route: "/flint" },
    { name: "Emergency passport services in Bay City, MI", route: "/bay-city" },
    { name: "Urgent passport services in Midland, MI", route: "/midland" },
    { name: "Michigan passport services overview", route: "/michigan" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Saginaw, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the 100-mile drive or appointment wait. Saginaw residents can ship from any UPS or FedEx in Saginaw County.",
  fpcOfficeDistance: "Serving Saginaw, Saginaw Township, Bay City, Midland, Frankenmuth, Bridgeport, Freeland, Buena Vista, and all of the Great Lakes Bay region",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Saginaw and the greater Great Lakes Bay region. From the Saginaw River waterfront to the Frankenmuth tourist district, from Bay City to Midland — we serve all of the central Michigan corridor. The Detroit Passport Agency is approximately 100 miles southeast, and our couriers have direct access to it.",
  nearbyCitiesIntro: "We serve Saginaw and all Saginaw County communities including Saginaw Township, Bay City, Midland, Frankenmuth, Bridgeport, Freeland, Buena Vista, Hemlock, Merrill, St. Charles, Birch Run, Clio, Mount Morris, and Vassar. We also serve Great Lakes Bay travelers and MBS International Airport flyers.",
  howItWorksIntro: "Most Saginaw travelers complete everything online and ship documents overnight. No driving 100 miles to the Detroit Passport Agency or waiting weeks for an appointment — our registered couriers handle the submission for you.",
  mistakesIntro: "Saginaw is a unique Great Lakes Bay community with heavy MBS International Airport travel, Frankenmuth tourism, and international family visits. Here are the most common passport mistakes we see from Saginaw County travelers.",
  testimonialsIntro: "Saginaw travelers — from MBS International Airport flyers to Frankenmuth tourists to international families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Saginaw, MI? Here are the most common ones we hear from Saginaw County and Great Lakes Bay travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for MBS Airport and Great Lakes Bay travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person in Detroit — 100-mile drive", "Full day commitment — parking + wait time"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Saginaw travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute MBS International Airport flights, family emergencies, and Frankenmuth group travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "MBS Airport and Great Lakes Bay travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Saginaw adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Saginaw County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Saginaw residents and families — including international students, new citizens, and Great Lakes Bay families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Saginaw residents who lost their passport before international travel or MBS Airport departure.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Saginaw-area families planning international vacations, Frankenmuth trips, or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Saginaw and Great Lakes Bay residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Saginaw MI", description: "Urgent passport processing for Saginaw Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Saginaw MI", description: "Fast passport renewal for Saginaw Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Saginaw MI", description: "New passport application services for Saginaw Michigan residents applying for their first passport." },
    { name: "Child Passport Saginaw MI", description: "Minor passport services for Saginaw Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Stephanie M.",
      location: "Saginaw, MI",
      rating: 5,
      text: "Flying out of MBS to Cancun in 5 days and my passport was expired. Fast Passport Center saved the trip — renewed in 3 days. I shipped from the UPS Store on Bay Road and had it back before I even packed.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Michael T.",
      location: "Bay City, MI",
      rating: 5,
      text: "Business trip to Germany in 4 days and my passport was lost. Fast Passport Center had a replacement in my hands in 48 hours. No driving to Detroit, no appointment wait. Their courier service is a lifesaver for the Great Lakes Bay.",
      service: "Lost Passport Replacement",
    },
    {
      name: "Rebecca K.",
      location: "Midland, MI",
      rating: 5,
      text: "Family trip to Italy with 10 days notice. Five passports for our family. Fast Passport Center processed all of them in 5 days. They caught a mistake on one of my kid's forms that would have delayed us.",
      service: "Family Passport Bundle",
    },
    {
      name: "David H.",
      location: "Frankenmuth, MI",
      rating: 5,
      text: "Tour group going to Europe and I realized my passport was expiring too soon. Fast Passport Center got me a renewed passport in 2 days. I shipped from the FedEx in Saginaw and everything was seamless.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "saginaw-1",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "230 S Dearborn St, Suite 380",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 100 miles southeast of Saginaw — appointments typically booked 2 weeks out",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Serves travelers with international travel within 14 days (or 28 days with visa). Appointments are required — no walk-ins. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
    {
      id: "saginaw-2",
      name: "Saginaw Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " 123 N. Washington Ave",
      city: "Saginaw",
      state: "MI",
      zip: "48607",
      phone: "(989) 752-6341",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Saginaw — near the riverfront",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Saginaw acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown Saginaw and riverfront area residents.",
      icon: "ri-mail-line",
    },
    {
      id: "saginaw-3",
      name: "Saginaw Township Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " 4880 Gratiot Rd",
      city: "Saginaw",
      state: "MI",
      zip: "48638",
      phone: "(989) 781-2775",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Saginaw Township — west of downtown Saginaw",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Saginaw Township and western Saginaw County residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "saginaw-4",
      name: "Bay City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " 1000 Washington Ave",
      city: "Bay City",
      state: "MI",
      zip: "48708",
      phone: "(989) 893-0074",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Bay City — approximately 20 miles north of Saginaw",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Bay City and northern Saginaw County residents. Larger facility with more appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "saginaw-5",
      name: "Midland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " 2900 Rodd St",
      city: "Midland",
      state: "MI",
      zip: "48640",
      phone: "(989) 631-2010",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Midland — approximately 25 miles west of Saginaw",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Midland and western Saginaw County residents. Book early during summer travel season.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must appear at 211 W. Fort St", fpc: "No — ship from anywhere in Saginaw County" },
    { feature: "MBS Airport & Great Lakes Bay Expertise", agency: "No tailored advice", fpc: "Yes — MBS International Airport and Great Lakes Bay travel" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Saginaw and Great Lakes Bay travelers often discover passport issues right before MBS International Airport departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Using a Passport Card for International Air Travel",
      description: "Some Saginaw-area travelers assume a passport card is sufficient for all travel — but passport cards are only valid for land and sea border crossings. All international flights require a passport book.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Saginaw County acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking MBS International Airport Flight Requirements",
      description: "MBS International Airport (Saginaw/Bay City/Midland) has limited international flight options. Many Saginaw travelers connect through DTW or Chicago O'Hare. Verify passport requirements for all connecting airports.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Saginaw County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Saginaw, Bay City, or Midland." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no 100-mile drive or appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Saginaw County address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the nearest passport agency to Saginaw, MI?", a: "The Detroit Passport Agency is the nearest regional passport agency to Saginaw, located at 230 S Dearborn St, Suite 380, Chicago, IL 60604 — approximately 100 miles southeast. It is open Monday through Friday 8:00 AM – 3:00 PM by appointment only. Appointments are typically booked 2 weeks out. Fast Passport Center's registered couriers have direct access and can submit applications without individual appointments, saving you the long drive and wait." },
    { q: "How fast can I get an emergency passport in Saginaw?", a: "Fast Passport Center offers emergency passport processing in Saginaw, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to drive 100 miles southeast or take a day off work." },
    { q: "Do I need a passport for international flights from MBS International Airport?", a: "Yes. All international flights from MBS International Airport (Saginaw/Bay City/Midland) require a passport book. While MBS primarily serves domestic destinations, many Saginaw travelers connect through Detroit Metro (DTW) or Chicago O'Hare for international flights. A passport book is required for all international air travel regardless of your departure airport." },
    { q: "Can I get an expedited passport in the Saginaw suburbs like Saginaw Township or Bridgeport?", a: "Absolutely. Fast Passport Center serves all of Saginaw County including Saginaw Township, Bridgeport, Buena Vista, Freeland, Frankenmuth, and all surrounding communities. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
    { q: "What airports do Saginaw-area travelers use for international flights?", a: "MBS International Airport (MBS) in Freeland is the local airport for Saginaw, Bay City, and Midland — primarily domestic flights with some connections. Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international departure hub — approximately 100 miles southeast. Many Saginaw travelers also use Chicago O'Hare (ORD) for international connections. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Saginaw, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Saginaw-area residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Saginaw, Bay City, and Midland offer passport photos. UPS Stores, FedEx Office locations, and many AAA offices also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve the Upper Peninsula from Saginaw?", a: "Yes. Fast Passport Center serves all of Michigan including the Upper Peninsula. Our courier service is especially valuable for remote UP communities, which would otherwise face an 8+ hour drive to the Detroit Passport Agency. We serve Marquette, Sault Ste. Marie, Houghton, Escanaba, and all UP communities — you just ship your documents overnight and we handle everything from there." },
  ],
  photoLocations: [
    { name: "Walgreens — Bay Road", address: "3030 Bay Rd, Saginaw, MI 48603", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Saginaw", address: " 3535 Bay Rd, Saginaw, MI 48603", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Saginaw", address: " 4675 Bay Rd, Saginaw, MI 48604", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Midland", address: " 6800 Eastman Ave, Midland, MI 48642", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Saginaw", address: " 3030 Bay Rd, Saginaw, MI 48603", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Serves Saginaw, Saginaw Township, and central Saginaw County. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Bay City", address: " 1000 Washington Ave, Bay City, MI 48708", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Bay City, Essexville, and northern Saginaw County communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "MBS",
      name: "MBS International Airport",
      distance: "Located in Freeland — approximately 10 miles southwest of Saginaw",
      address: "8500 Garfield Rd, Freeland, MI 48623",
      note: "Regional airport serving Saginaw, Bay City, and Midland. Primarily domestic flights with connections to major hubs. Delta, United, and American service. Not a major international gateway — most Saginaw travelers connect through DTW or Chicago O'Hare for international flights.",
      flightUrl: "https://www.mbsairport.com/",
      flightLabel: "MBS Airport Info",
      featured: false,
    },
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "Approximately 100 miles southeast of Saginaw via I-75",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for the Great Lakes Bay region. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Largest airport in Michigan. Most Saginaw international travelers connect through DTW.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
  ],
};